import { render, staticRenderFns } from "./devCustom.vue?vue&type=template&id=71481f34&scoped=true&"
import script from "./devCustom.vue?vue&type=script&lang=js&"
export * from "./devCustom.vue?vue&type=script&lang=js&"
import style0 from "./devCustom.vue?vue&type=style&index=0&id=71481f34&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71481f34",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/www/game/xcp-vue-xcll/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('71481f34')) {
      api.createRecord('71481f34', component.options)
    } else {
      api.reload('71481f34', component.options)
    }
    module.hot.accept("./devCustom.vue?vue&type=template&id=71481f34&scoped=true&", function () {
      api.rerender('71481f34', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/view/formSys/components/devCustom.vue"
export default component.exports